import ErrorKey from '@/util/ErrorKey';

export default {
  dismissError: 'Ok',
  pageNotFound: 'Inhalt nicht gefunden',
  pageNotFoundDetail: 'Leider können wir diesen Inhalt nicht (mehr) finden. ' +
    'Falls Sie eines unserer aktuellen Produkte suchen, können Sie das über unsere Suche tun.',

  [ErrorKey.NoServerResponse]:
    'Fehler bei der Kommunikation mit dem Server. Bitte überprüfen Sie Ihre Internetverbindung.',
  [ErrorKey.UnknownBackendError]: 'Unerwarteter Serverfehler.',
  [ErrorKey.GenericSave]: 'Daten konnten nicht gespeichert werden.',
  [ErrorKey.WrongAddress]: 'Die eingegebene Adresse ist nicht zulässig.',
  [ErrorKey.NoCart]: 'Diese Aktion erfordert einen Warenkorb.',
  [ErrorKey.UnitNotFound]:
    'Produkt {0} konnte nicht in den Warenkorb gelegt werden. Unbekannte Einheit {1}.',
  [ErrorKey.NoSuchCartItem]: 'Dieses Produkt befindet sich nicht im Warenkorb.',
  [ErrorKey.AlreadyPending]: 'Operation läuft noch, bitte warten.',

  [ErrorKey.LoginStatusCheckFailed]: 'Fehler bei der Prüfung der Authentifizierung.',
  [ErrorKey.CartMergeAction]: 'Fehler beim Zusammenführen des Gastwarenkorbs.',
  [ErrorKey.CartFetchAction]: 'Warenkorb konnte nicht geladen werden.',
  [ErrorKey.CartSaveAction]: 'Warenkorb konnte nicht gespeichert werden.',
  [ErrorKey.AddressListFetchAction]: 'Adressen konnten nicht geladen werden.',
  [ErrorKey.AddressSaveAction]: 'Adresse konnte nicht gespeichert werden.',
  [ErrorKey.AddressDeleteAction]: 'Adresse konnte nicht gelöscht werden.',
  [ErrorKey.CategoriesFetchAction]: 'Warengruppen konnten nicht geladen werden.',
  [ErrorKey.LanguageChangeAction]: 'Sprache konnte nicht geändert werden.',
  [ErrorKey.UserFetchAction]: 'Benutzer konnte nicht geladen werden.',
  [ErrorKey.UserPageSizeSaveAction]: 'Anzahl der Elemente pro Seite konnte nicht gespeichert werden.',
  [ErrorKey.UserCreateAction]: 'Ihre Registrierung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
  [ErrorKey.UserUpdateAction]: 'Ihre Benutzerdaten konnten nicht gespeichert werden.',
  [ErrorKey.ProductListFetchAction]: 'Artikel konnten nicht geladen werden.',
  [ErrorKey.ProductDetailFetchAction]: 'Artikel konnte nicht geladen werden.',
  [ErrorKey.KeycloakInitializationAction]: 'Verbindung zum Login-Server fehlgeschlagen.',
  [ErrorKey.ShopMinOrderValueFetchAction]: 'Fehler beim Abfragen der Einstellungen.',
  [ErrorKey.CmsFetchAction]: 'Fehler beim Holen der dynamischen Inhalte',

  [ErrorKey.ConflictException]: 'Diese Anfrage steht in Konflikt mit bereits vorhandenen Daten.',
  [ErrorKey.DisabledUserException]: 'Der Benutzeraccount {0} ist deaktiviert.',
  [ErrorKey.DuplicateEmailException]: 'Die Email-Adresse {0} wird bereits verwendet.',
  [ErrorKey.EmptyOrderException]: 'Bitte fügen Sie etwas zu Ihrer Bestellung hinzu.',
  [ErrorKey.ForbiddenShopException]:
    'Ihr Benutzer ist dem Webshop von {0} nicht zugeordnet. Verwenden Sie den richtigen Benutzeraccount?',
  [ErrorKey.ForbiddenTenantException]:
    'Ihr Benutzer ist dem Mandanten {0} nicht zugeordnet. Verwenden Sie den richtigen Benutzeraccount?',
  [ErrorKey.ForbiddenUserException]: 'Ihr Benutzer {0} ist für diese Aktion nicht berechtigt.',
  [ErrorKey.IllegalShopException]: 'Der Webshop {0} existiert nicht.',
  [ErrorKey.InvalidEssentialFilterException]: 'Essenzfilter {0} wird nicht unterstützt.',
  [ErrorKey.InvalidInputException]: 'Unzulässige Eingabe im Feld {0}.',
  [ErrorKey.InvalidShoppingCartAmountException]: 'Die Mindestbestellmenge für den Artikel {1} ist nicht erreicht.',
  [ErrorKey.MinSaleQuantityViolationException]:
  'Die Mindestbestellmenge für den Artikel {0} ist nicht erreicht. ' +
  'Bitte bestellen Sie zumindest {1} Einheiten. (Ihre Menge: {2})',
  [ErrorKey.MissingTenantSettingsException]: 'Mandantenspezifische Einstellungen fehlen für {0}.',
  [ErrorKey.NoCategoryForProductException]: 'Interner Fehler: Artikel {0} ist keiner Warengruppe zugeordnet.',
  [ErrorKey.NoInvoiceAPIException]: 'Der Rechnungszugriff für {0} ist nicht eingerichtet.',
  [ErrorKey.NonEssentialProductException]: 'Der Artikel {0} befindet sich nicht in "Meine Produkte". ({1})',
  [ErrorKey.NoSuchAddressException]: 'Die Adresse {0} konnte nicht gefunden werden.',
  [ErrorKey.NoSuchCartItemException]: 'Der Artikel {0} liegt nicht im Warenkorb.',
  [ErrorKey.NoSuchCategoryException]: 'Die Warengruppe {0} konnte nicht gefunden werden.',
  [ErrorKey.NoSuchOrderException]: 'Die Bestellung {0} konnte nicht gefunden werden.',
  [ErrorKey.NoSuchProductException]: 'Der Artikel {0} konnte nicht gefunden werden.',
  [ErrorKey.NoSuchShoppingCartException]: 'Der Warenkorb {0} konnte nicht gefunden werden.',
  [ErrorKey.NoSuchUnitException]: 'Der Artikel {1} besitzt keine Einheit {0}.',
  [ErrorKey.NoSuchUserException]: 'Der Benutzer {0} konnte nicht gefunden werden.',
  [ErrorKey.IndexNotFoundException]: 'Suche konnte nicht durchgeführt werden.',
  [ErrorKey.ElasticsearchException]: 'Suche konnte nicht durchgeführt werden.',
  [ErrorKey.NoNodeAvailableException]: 'Die Suche ist momentan nicht verfügbar. Bitte versuchen Sie es später erneut.',
  [ErrorKey.AccessControlException]: 'Ihr Benutzer hat dafür keine Berechtigung.',
  [ErrorKey.TenantAccessDeniedException]:
    'Ihr Benutzer ist dem Mandanten {0} nicht zugeordnet. Verwenden Sie den richtigen Benutzeraccount?',
  [ErrorKey.ShopAccessDeniedException]:
    'Ihr Benutzer ist dem Webshop von {0} nicht zugeordnet. Verwenden Sie den richtigen Benutzeraccount?',
  [ErrorKey.CanNotDeleteDefaultAddress]: 'Bitte wählen Sie eine andere Standardadresse, bevor Sie diese löschen.',
  [ErrorKey.DeliveryNotSupportedException]: 'Diese Adresse befindet sich nicht im Liefergebiet.',
  [ErrorKey.MissingOrderAddressException]: 'Liefer- oder Rechnungsadresse fehlt.',
  [ErrorKey.DeliverySlotExpiryException]: 'Dieser Lieferslot ist nicht mehr verfügbar.',
  [ErrorKey.ExternalException]: 'Fehler bei der Kommunikation mit einem externen System: {0}',
  [ErrorKey.NoSuchMegacardException]: 'Keine Megacard mit dieser Nummer und PLZ gefunden.',
  [ErrorKey.MegacardConflictException]: 'Sie haben bereits eine Megacard.',
  [ErrorKey.MegacardImportException]: 'Fehler bei Abfrage der Megacard-Daten.',
  [ErrorKey.UpdateDefaultAddress]: 'Die Standard-Adresse konnte nicht geändert werden.',
  [ErrorKey.AgeRestrictionException]: 'Wegen des Verkaufs von alkoholhaltigen Getränken ist ein Mindestalter von ' +
  '18 Jahren erforderlich.',
  [ErrorKey.CmsNotFoundException]: 'Dieser dynamische Inhalt konnte leider nicht gefunden werden.',
  [ErrorKey.NoSuchShoppingListException]: 'Die Einkaufsliste konnte nicht gefunden werden.',
  [ErrorKey.MissingAddressException]: 'Bitte geben Sie eine Adresse an.',
  [ErrorKey.ErpStatusException]: 'Fehler bei der Kommunikation mit einem internen System. ' +
  'Bitte versuchen Sie es später erneut oder wenden Sie sich an uns. ({0})',
  [ErrorKey.ErpConnectException]: 'Fehler bei der Verbindung zu einem internen System. ' +
  'Bitte versuchen Sie es später erneut oder wenden Sie sich an uns.',
};
